import React, { useState } from 'react';
import { Copy, CheckCircle } from 'lucide-react';
import { useWeb3 } from '../../contexts/Web3Context';
import { useUI } from '../../contexts/UIContext';

const ReferralBox = ({ userId }) => {
  const [copied, setCopied] = useState(false);
  const { showAiMessage } = useUI();
  
  // Generate referral link
  const getReferralLink = () => {
    if (userId > 0) {
      return `${window.location.origin}${window.location.pathname}?ref=${userId}`;
    }
    return 'Make your first investment to get your referral link';
  };

  const referralLink = getReferralLink();

  // Copy referral link to clipboard
  const copyReferralLink = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    showAiMessage('Referral link copied to clipboard! Share it with your friends to earn rewards.');
    
    // Reset copied state after 2 seconds
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <div className="referral-box">
      <h2>Your Referral Link</h2>
      <div className="referral-link-container">
        <input 
          type="text" 
          value={referralLink} 
          readOnly
        />
        <button onClick={copyReferralLink}>
          {copied ? <CheckCircle size={18} /> : <Copy size={18} />}
        </button>
      </div>
      <p>Share this link with others to earn referral bonuses!</p>
    </div>
  );
};

export default ReferralBox;
